import { AzureGroupInfoResponse } from '@mnspro-cloud/services/lib/mnspro-cloud/api/v2';
import {
  CourseMapping,
  CourseMappingDisplayModel,
  ImportIssue,
  MappingsFilter,
} from '../CourseMapping.interfaces';
import { ActionTypes } from './CourseMapping.actiontypes';
import {
  importMappingsInState,
  resetMappingsInState,
  setAllowMultipleAzureGroupUsageInState,
  setCloudCoursesInState,
  setHasChangesInState,
  setImportIssuesInState,
  setInitialMappingsInState,
  setItemsPerPageInState,
  setMappingsFilterInState,
  setPageInState,
  setTimetableCoursesInState,
  updateSingleMappingInState,
} from './CourseMapping.reducer.utils';
import { Action } from './CourseMapping.redux.interfaces';
import { CourseMappingState, createInitialState } from './CourseMapping.state';

export const courseMappingReducer = (
  state: CourseMappingState = createInitialState(),
  action: Action<any>,
): CourseMappingState => {
  switch (action.type) {
    case ActionTypes.SetTimetableCourses: {
      return {
        ...setTimetableCoursesInState(state, action.payload),
      };
    }
    case ActionTypes.SetCloudCourses: {
      return { ...setCloudCoursesInState(state, action.payload) };
    }
    case ActionTypes.UpdateSingleMapping: {
      return {
        ...updateSingleMappingInState(state, action.payload),
      };
    }
    case ActionTypes.SetErrorMessage:
      return { ...state, error: action.payload };
    case ActionTypes.SetInitialMappings: {
      return {
        ...setInitialMappingsInState(state, action.payload),
      };
    }
    case ActionTypes.SetMappingFilter: {
      return {
        ...setMappingsFilterInState(state, action.payload),
      };
    }
    case ActionTypes.ResetMappings: {
      return {
        ...resetMappingsInState(state),
      };
    }
    case ActionTypes.SetPage: {
      return {
        ...setPageInState(state, action.payload),
      };
    }
    case ActionTypes.SetItemsPerPage: {
      return {
        ...setItemsPerPageInState(state, action.payload),
      };
    }
    case ActionTypes.SetHasChanges: {
      return { ...setHasChangesInState(state, action.payload) };
    }
    case ActionTypes.ImportMappings: {
      return { ...importMappingsInState(state, action.payload) };
    }
    case ActionTypes.SetImportIssues: {
      return { ...setImportIssuesInState(state, action.payload) };
    }
    case ActionTypes.SetAllowMultipleAzureGroupUsage: {
      return {
        ...setAllowMultipleAzureGroupUsageInState(state, action.payload),
      };
    }
    default:
      return state;
  }
};

export const getMappingsFilter = (state: CourseMappingState): MappingsFilter =>
  state.mappingsFilter;
export const getCloudCourses = (
  state: CourseMappingState,
): AzureGroupInfoResponse[] | null => state.cloudCourses;
export const getCourseMappings = (
  state: CourseMappingState,
): CourseMappingDisplayModel[] | null => state.courseMappings;
export const getVisibleItems = (
  state: CourseMappingState,
): CourseMappingDisplayModel[] | null => state.visibleItems;
export const getInitialMappings = (
  state: CourseMappingState,
): CourseMapping[] | null => state.initialMappings;
export const getHasChanges = (state: CourseMappingState): boolean =>
  state.hasChanges;
export const getEntriesPerPage = (state: CourseMappingState): number =>
  state.itemsPerPage;
export const getMaxPage = (state: CourseMappingState): number => state.maxPage;
export const getPage = (state: CourseMappingState): number => state.page;
export const getImportIssues = (state: CourseMappingState): ImportIssue[] =>
  state.importIssues;
export const getError = (state: CourseMappingState): string | null =>
  state.error;
